// @flow
import React from "react";
import EvCharging from "../../../svg/facilities/has_ev_charging.svg";
import "./evChargingIcon.scss";

const EvChargingIcon = () => <EvCharging className="c-ev-charging-icon" />;

export default EvChargingIcon;
